import { Button, Icon } from 'ui';

type P = {
  block?: boolean;
  loading: boolean;
  onEnter: () => void;
  size: 'large' | 'small';
};

const EventJoinButton = ({ block, loading, onEnter, size }: P) => (
  <Button
    block={block}
    icon={<Icon icon="camcorder-line" />}
    loading={loading}
    onClick={(onClickEvent) => {
      onClickEvent.preventDefault();
      onEnter();
    }}
    size={size}
    type="primary"
  >
    Join video
  </Button>
);

export default EventJoinButton;
